module.exports = __webpack_public_path__ + "img/Design10 Back.c038ab3d.png";